import { Form, FormItemProps } from '@bancobarigui/barihaus';
import { MaskedInput } from '@/shared/components/MaskedInput';

export function PhoneTypeFormItem({ ...rest }: FormItemProps) {
  return (
    <Form.Item
      name="phone"
      label="Telefone"
      rules={[{ required: true, message: 'Informe um telefone.' }]}
      {...rest}
    >
      <MaskedInput mask="(00) 00000-0000" placeholder="(00) 00000-0000" autoComplete="tel" />
    </Form.Item>
  );
}
